import { render, staticRenderFns } from "./abnormalCall.vue?vue&type=template&id=d395967c&scoped=true&"
import script from "./abnormalCall.vue?vue&type=script&lang=js&"
export * from "./abnormalCall.vue?vue&type=script&lang=js&"
import style0 from "./abnormalCall.vue?vue&type=style&index=0&id=d395967c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d395967c",
  null
  
)

export default component.exports